import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { filter } from 'rxjs';
import { Question } from 'src/app/core/models/questionnaire.model';
import { DocumentUploadModalComponent } from '../document-upload-modal/document-upload-modal.component';
import { QuestionAnswer } from '../question/question.component';

@Component({
  selector: 'app-question-multi-file',
  templateUrl: './question-multi-file.component.html',
  styleUrls: ['./question-multi-file.component.scss'],
})
export class QuestionMultiFileComponent implements OnInit {
  @Input('question') question!: Question;
  @Input('context') context!: QuestionContext;
  @Output('changeAnswer') changeAnswer: EventEmitter<QuestionAnswer> =
    new EventEmitter();

  dialogData?: {
    bucket: string;
    name: string;
    type: 'PERSONAL' | 'CLAIM';
    multiple: boolean;
    ref: string;
    maxFileSize?: number;
    maxFiles?: number;
    question_id?: string;
  };

  filesLength: number = 0;

  constructor(public dialog: MatDialog) {}

  ngOnInit(): void {
    this.filesLength =
      (this.question.answer?.value as unknown as string[])?.length ?? 0;
  }

  change(ev: QuestionAnswer) {
    this.changeAnswer.next(ev);
  }

  openModal() {
    const limit = this.question.configuration?.limit;
    this.dialogData = {
      bucket: this.question.configuration.bucket,
      name: this.question.slug,
      multiple: limit > 1,
      ref: this.context.claim_id!,
      // provide the question id so uploads can be associated to the question
      question_id: this.question.id,
      type: 'CLAIM',
      maxFileSize: this.question.configuration?.maxFileSize,
      maxFiles: typeof limit === 'number' && limit > 0 ? limit : 1,
    };

    const dialogRef = this.dialog.open(DocumentUploadModalComponent, {
      data: this.dialogData,
    });

    dialogRef
      .afterClosed()
      .pipe(filter((e) => !!e))
      .subscribe((result) => {
        console.log(`Dialog result: ${result}`);
        const parsed = JSON.parse(result);
        console.log(`Parsed result: ${parsed.value}`);
        if (parsed.status == 'COMPLETED') {
          this.question.isValid = this.checkValid(parsed.value);
          this.question.answer = { value: parsed.value };
          this.filesLength = parsed?.value?.length ?? 0;

          this.change({
            answer: { value: parsed.value },
            question: this.question,
          });
        } else {
          this.filesLength = 0;
        }
      });
  }

  checkValid(value?: string): boolean {
    if (!this.question.configuration?.required && !value) {
      return true;
    }

    if (this.question.configuration.required && !value) {
      return false;
    }

    return true;
  }
}

export interface QuestionContext {
  claim_id: string;
  index?: number;
}
